import { UserName, UserSubtitle } from 'features/user/components/Info';
import { userInfo } from 'features/user/config/defaults';
import { UserInfoWithSubtitle as UserInfoWithSubtitleType } from 'features/user/config/types';

import { Avatar } from 'shared/components/Avatar';
import { Flex } from 'shared/components/Flex';
import Spacer from 'shared/components/Spacer';

type UserInfoWithTitleProps = UserInfoWithSubtitleType;

export const UserInfoWithSubtitle = ({
  pictureUrl,
  name,
  subtitle,
  pictureSize = userInfo.pictureSize,
  maxWidth = userInfo.maxWidth,
}: UserInfoWithTitleProps) => (
  <Flex as="span" alignItems="center" justifyContent="flex-start">
    <Avatar name={name} size={pictureSize} src={pictureUrl} />
    <Spacer as="span" size="zr zr zr md">
      <Spacer size="zr zr sm zr">
        <UserName maxWidth={maxWidth}>{name}</UserName>
      </Spacer>
      {subtitle !== name ? (
        <UserSubtitle maxWidth={maxWidth}>{subtitle}</UserSubtitle>
      ) : null}
    </Spacer>
  </Flex>
);
